import { useTranslation } from "react-i18next";
import Header from "../../components/special/Header";
import ExoContractPreset from "../../components/exo/ExoContractPreset";

const ContractPresets = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header title={t("Contract Templates")} />
      <ExoContractPreset type="contract" />
    </>
  );
};

export default ContractPresets;
